(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["eg-hosp-categories"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function prefixOf(anchor) {
      var a = (anchor || '').replace('#', '').trim();
      if (!a) return '';
      return a.split('-')[0];
    }

    function sectionsForPrefix(prefix) {
      var out = [];
      if (!prefix) return out;
      var nodes = document.querySelectorAll('[id]');
      Array.prototype.forEach.call(nodes, function (el) {
        var id = el.id;
        if (id === prefix || id.indexOf(prefix + '-') === 0) {
          var sec = el.closest('.shopify-section');
          if (sec && out.indexOf(sec) === -1) out.push(sec);
        }
      });
      return out;
    }

    function initTabs(root) {
      var buttons = Array.prototype.slice.call(root.querySelectorAll('[data-eg-tab]'));
      if (!buttons.length) return;
      var noteEl = root.querySelector('[data-eg-note]');

      var groups = buttons.map(function (btn) {
        var prefix = prefixOf(btn.getAttribute('data-anchor'));
        return { btn: btn, prefix: prefix, sections: sectionsForPrefix(prefix) };
      });

      function activate(idx) {
        groups.forEach(function (g, i) {
          var on = i === idx;
          g.btn.classList.toggle('is-active', on);
          g.btn.setAttribute('aria-selected', on ? 'true' : 'false');
          g.sections.forEach(function (s) { s.style.display = on ? '' : 'none'; });
        });
        if (noteEl) noteEl.textContent = buttons[idx].getAttribute('data-note') || '';
      }

      buttons.forEach(function (btn, i) {
        btn.addEventListener('click', function () { activate(i); });
      });

      function groupForHash(hash) {
        var p = prefixOf(hash);
        if (!p) return -1;
        for (var i = 0; i < groups.length; i++) {
          if (groups[i].prefix === p) return i;
        }
        return -1;
      }

      document.addEventListener('click', function (e) {
        var link = e.target.closest('a[href*="#"]');
        if (!link) return;
        var href = link.getAttribute('href') || '';
        var hashIndex = href.indexOf('#');
        if (hashIndex < 0) return;
        var gi = groupForHash(href.slice(hashIndex));
        if (gi >= 0) activate(gi);
      });

      var initial = groupForHash(window.location.hash);
      activate(initial >= 0 ? initial : 0);
    }

    function initAll() {
      document.querySelectorAll('[data-eg-hcat-tabs]').forEach(initTabs);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAll);
    } else {
      initAll();
    }
    document.addEventListener('shopify:section:load', initAll);
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["look-scene"] && !Shopify.designMode) return;
  try {
    
  // Shop the Look scene behaviour. Cart wiring is Horizon-native: POST /cart/add.js,
  // dispatch the theme "cart:update" event on document (so cart bubble + drawer
  // contents refresh), then open the cart-drawer-component. No theme files touched.

  const LookSceneCart = {
    async addLines(lines, sourceEl) {
      const sections = LookSceneCart.cartSectionIds();
      const res = await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: lines, sections: sections.join(','), sections_url: window.location.pathname }),
      });
      if (!res.ok) {
        let message = 'Could not add to cart';
        try {
          const err = await res.json();
          message = err.description || err.message || message;
        } catch (e) {}
        throw new Error(message);
      }
      const data = await res.json();
      // Fetch the canonical cart so the bubble count and totals are exact.
      let cart = null;
      try {
        cart = await (await fetch('/cart.js', { headers: { Accept: 'application/json' } })).json();
      } catch (e) {}
      LookSceneCart.notify(cart, data.sections, sourceEl);
      return cart;
    },

    cartSectionIds() {
      const ids = new Set();
      document.querySelectorAll('[id^="shopify-section"]').forEach((el) => {
        const id = el.id.replace('shopify-section-', '');
        if (/cart|header/i.test(el.className) || /cart|header/i.test(id)) ids.add(id);
      });
      return Array.from(ids);
    },

    notify(cart, sections, sourceEl) {
      const detail = {
        resource: cart,
        sourceId: sourceEl ? sourceEl.id || 'look-scene' : 'look-scene',
        data: {
          source: 'look-scene',
          itemCount: cart ? cart.item_count : undefined,
          sections: sections,
        },
      };
      // Horizon CartAddEvent.eventName === 'cart:update'. The cart drawer + bubble
      // listen for this on document.
      document.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
      LookSceneCart.openDrawer();
    },

    openDrawer() {
      const drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        // Defer so the drawer re-renders with the new line before opening.
        requestAnimationFrame(() => {
          try { drawer.open(); } catch (e) {}
        });
        return;
      }
      // Fallback: trigger the drawer toggle, else go to the cart page.
      const trigger = document.querySelector('[data-testid="cart-drawer-trigger"]');
      if (trigger) trigger.click();
    },
  };

  // Money formatter (standard Shopify tokens) so the subtotal can be recomputed
  // live when a row's variant selection changes. Reads the shop money format from
  // the element's data-money-format attribute; falls back to a plain $ format.
  const LookSceneMoney = {
    format(cents, formatString) {
      if (typeof cents === 'string') cents = cents.replace('.', '');
      let value = '';
      const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      const fmt = formatString || '${{amount}}';
      function defaultTo(num, def) { return (num === undefined || num === null) ? def : num; }
      function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultTo(precision, 2);
        thousands = defaultTo(thousands, ',');
        decimal = defaultTo(decimal, '.');
        if (isNaN(number) || number == null) return 0;
        number = (number / 100.0).toFixed(precision);
        const parts = number.split('.');
        const dollarsArr = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
        const centsPart = parts[1] ? decimal + parts[1] : '';
        return dollarsArr + centsPart;
      }
      const match = fmt.match(placeholderRegex);
      const token = match ? match[1] : 'amount';
      switch (token) {
        case 'amount':
          value = formatWithDelimiters(cents, 2);
          break;
        case 'amount_no_decimals':
          value = formatWithDelimiters(cents, 0);
          break;
        case 'amount_with_comma_separator':
          value = formatWithDelimiters(cents, 2, '.', ',');
          break;
        case 'amount_no_decimals_with_comma_separator':
          value = formatWithDelimiters(cents, 0, '.', ',');
          break;
        case 'amount_with_apostrophe_separator':
          value = formatWithDelimiters(cents, 2, "'", '.');
          break;
        case 'amount_with_space_separator':
          value = formatWithDelimiters(cents, 2, ' ', ',');
          break;
        case 'amount_no_decimals_with_space_separator':
          value = formatWithDelimiters(cents, 0, ' ', '');
          break;
        default:
          value = formatWithDelimiters(cents, 2);
      }
      return fmt.replace(placeholderRegex, value);
    },
  };

  function lookBtnBusy(btn, busy) {
    if (!btn) return;
    btn.toggleAttribute('aria-busy', busy);
    if (busy) btn.setAttribute('disabled', '');
    else btn.removeAttribute('disabled');
  }

  // ----- Hotspots: one popover open at a time, Esc closes, click-outside closes -----
  class LookHotspots extends HTMLElement {
    connectedCallback() {
      this.openSpot = null;
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('keydown', this.onKeydown.bind(this));
      this._onDocClick = this.onDocClick.bind(this);
      document.addEventListener('click', this._onDocClick);
    }
    disconnectedCallback() {
      document.removeEventListener('click', this._onDocClick);
    }
    onClick(event) {
      const dot = event.target.closest('[data-look-dot]');
      if (dot) {
        const spot = dot.closest('.look-hotspot');
        if (spot === this.openSpot) this.close();
        else this.open(spot);
        return;
      }
      const closeBtn = event.target.closest('[data-look-pop-close]');
      if (closeBtn) {
        this.close({ focusDot: true });
        return;
      }
      const addBtn = event.target.closest('[data-look-add]');
      if (addBtn) this.handleAdd(addBtn);
    }
    onKeydown(event) {
      if (event.key === 'Escape' && this.openSpot) {
        event.stopPropagation();
        this.close({ focusDot: true });
      }
    }
    onDocClick(event) {
      if (this.openSpot && !this.contains(event.target)) this.close();
    }
    open(spot) {
      if (this.openSpot && this.openSpot !== spot) this.close();
      const pop = spot.querySelector('[data-look-pop]');
      const dot = spot.querySelector('[data-look-dot]');
      pop.hidden = false;
      // next frame so the opacity transition runs
      requestAnimationFrame(() => pop.setAttribute('data-open', ''));
      dot.setAttribute('aria-expanded', 'true');
      spot.style.zIndex = '6';
      this.openSpot = spot;
    }
    close(opts) {
      opts = opts || {};
      const spot = this.openSpot;
      if (!spot) return;
      const pop = spot.querySelector('[data-look-pop]');
      const dot = spot.querySelector('[data-look-dot]');
      pop.removeAttribute('data-open');
      dot.setAttribute('aria-expanded', 'false');
      spot.style.zIndex = '';
      const hide = () => { pop.hidden = true; };
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) hide();
      else setTimeout(hide, 200);
      this.openSpot = null;
      if (opts.focusDot && dot) dot.focus();
    }
    async handleAdd(btn) {
      const variantId = btn.getAttribute('data-variant-id');
      if (!variantId) return;
      const label = btn.querySelector('[data-look-add-label]');
      const original = label ? label.textContent : '';
      lookBtnBusy(btn, true);
      try {
        await LookSceneCart.addLines([{ id: Number(variantId), quantity: 1 }], btn);
        if (label) {
          label.textContent = btn.getAttribute('data-added-label') || 'Added';
          setTimeout(() => { label.textContent = original; }, 1600);
        }
      } catch (e) {
        if (label) {
          label.textContent = e.message || 'Try again';
          setTimeout(() => { label.textContent = original; }, 2000);
        }
      } finally {
        lookBtnBusy(btn, false);
      }
    }
  }
  if (!customElements.get('look-hotspots')) customElements.define('look-hotspots', LookHotspots);

  // ----- Bundle: quantity steppers, per-row variant select, per-row Add, Add all -----
  class LookBundle extends HTMLElement {
    connectedCallback() {
      this.addEventListener('click', this.onClick.bind(this));
      this.addEventListener('input', this.onInput.bind(this));
      this.addEventListener('change', this.onChange.bind(this));
      this.moneyFormat = this.getAttribute('data-money-format') || '';
    }
    onInput(event) {
      const input = event.target.closest('[data-look-qty-input]');
      if (!input) return;
      input.value = LookBundle.sanitize(input.value);
    }
    onChange(event) {
      const select = event.target.closest('[data-look-variant-select]');
      if (!select) return;
      this.onVariantChange(select);
    }
    // When a variant select changes: update the row's displayed price (from the
    // chosen option's pre-formatted money) and the data-variant-id fallback on the
    // row's Add button, then recompute the subtotal.
    onVariantChange(select) {
      const row = select.closest('[data-look-line]');
      if (!row) return;
      const opt = select.options[select.selectedIndex];
      if (opt) {
        const priceEl = row.querySelector('[data-look-price]');
        const formatted = opt.getAttribute('data-price-formatted');
        if (priceEl && formatted) priceEl.textContent = formatted;
        const addBtn = row.querySelector('[data-look-add]');
        if (addBtn) addBtn.setAttribute('data-variant-id', select.value);
      }
      this.updateSubtotal();
    }
    // Sum each row's selected variant price (cents) and reformat the subtotal.
    updateSubtotal() {
      const valueEl = this.querySelector('[data-look-subtotal]');
      if (!valueEl) return;
      let cents = 0;
      this.querySelectorAll('[data-look-line]').forEach((row) => {
        const select = row.querySelector('[data-look-variant-select]');
        if (select) {
          const opt = select.options[select.selectedIndex];
          const p = opt ? parseInt(opt.getAttribute('data-price'), 10) : NaN;
          if (!isNaN(p)) cents += p;
          return;
        }
        // Single-variant row: keep the server-rendered contribution.
        const base = parseInt(row.getAttribute('data-line-cents'), 10);
        if (!isNaN(base)) cents += base;
      });
      valueEl.textContent = LookSceneMoney.format(cents, this.moneyFormat);
      valueEl.setAttribute('data-subtotal-cents', cents);
    }
    static sanitize(val) {
      const n = parseInt(String(val).replace(/[^0-9]/g, ''), 10);
      return (!n || n < 1) ? 1 : n;
    }
    onClick(event) {
      const down = event.target.closest('[data-look-qty-down]');
      const up = event.target.closest('[data-look-qty-up]');
      if (down || up) {
        const qty = (down || up).closest('[data-look-qty]');
        const input = qty.querySelector('[data-look-qty-input]');
        let n = LookBundle.sanitize(input.value);
        n = up ? n + 1 : Math.max(1, n - 1);
        input.value = n;
        return;
      }
      const addAll = event.target.closest('[data-look-add-all]');
      if (addAll) { this.handleAddAll(addAll); return; }
      const add = event.target.closest('[data-look-add]');
      if (add) this.handleAddOne(add);
    }
    // Resolve the variant id for a row: the row's select if present, else the
    // Add button's data-variant-id (single-variant default).
    rowVariantId(row) {
      if (!row) return null;
      const select = row.querySelector('[data-look-variant-select]');
      if (select && select.value) return select.value;
      const add = row.querySelector('[data-look-add]');
      return add ? add.getAttribute('data-variant-id') : null;
    }
    rowQty(btn) {
      const row = btn.closest('.look-row');
      const input = row ? row.querySelector('[data-look-qty-input]') : null;
      return input ? LookBundle.sanitize(input.value) : 1;
    }
    status(msg) {
      const el = this.querySelector('[data-look-status]');
      if (el) el.textContent = msg || '';
    }
    async handleAddOne(btn) {
      const row = btn.closest('[data-look-line]') || btn.closest('.look-row');
      const variantId = this.rowVariantId(row) || btn.getAttribute('data-variant-id');
      if (!variantId) return;
      const original = btn.textContent;
      lookBtnBusy(btn, true);
      try {
        await LookSceneCart.addLines([{ id: Number(variantId), quantity: this.rowQty(btn) }], btn);
        btn.textContent = btn.getAttribute('data-added-label') || 'Added';
        setTimeout(() => { btn.textContent = original; }, 1600);
      } catch (e) {
        this.status(e.message || 'Could not add to cart');
        btn.textContent = original;
      } finally {
        lookBtnBusy(btn, false);
      }
    }
    async handleAddAll(btn) {
      const rows = Array.from(this.querySelectorAll('.look-row'));
      const items = [];
      rows.forEach((row) => {
        const variantId = this.rowVariantId(row);
        const input = row.querySelector('[data-look-qty-input]');
        if (variantId) {
          items.push({ id: Number(variantId), quantity: input ? LookBundle.sanitize(input.value) : 1 });
        }
      });
      if (!items.length) return;
      const label = btn.querySelector('[data-look-addall-label]');
      const original = label ? label.textContent : '';
      lookBtnBusy(btn, true);
      this.status('');
      try {
        // One user action -> one /cart/add.js call carrying every line.
        await LookSceneCart.addLines(items, btn);
        if (label) {
          label.textContent = btn.getAttribute('data-added-label') || 'Added to cart';
          setTimeout(() => { label.textContent = original; }, 1800);
        }
      } catch (e) {
        this.status(e.message || 'Could not add all to cart');
      } finally {
        lookBtnBusy(btn, false);
      }
    }
  }
  if (!customElements.get('look-bundle')) customElements.define('look-bundle', LookBundle);

  // ----- Shoppable (hybrid): numbered dots on the photo <-> numbered list rows.
  // Reuses the bundle quantity / variant select / per-row Add / Add-all + cart wiring,
  // and adds the dot<->row linking (click a dot to highlight + scroll its row;
  // hover/focus a row to emphasise its dot). One active row at a time, Esc clears,
  // reduced-motion aware.
  class LookShoppable extends LookBundle {
    connectedCallback() {
      super.connectedCallback();
      this.activeIndex = null;
      this.addEventListener('keydown', this.onShopKeydown.bind(this));
      // Emphasise the matching dot while a row is hovered or focused.
      this.addEventListener('pointerover', this.onRowPointer.bind(this));
      this.addEventListener('pointerout', this.onRowPointer.bind(this));
      this.addEventListener('focusin', this.onRowFocus.bind(this));
      this.addEventListener('focusout', this.onRowFocus.bind(this));
    }
    dotByIndex(i) { return this.querySelector('[data-look-hotspot][data-look-index="' + i + '"]'); }
    rowByIndex(i) { return this.querySelector('[data-look-row][data-look-index="' + i + '"]'); }
    onClick(event) {
      // Dot click: link to the matching numbered row. Let qty/add/add-all fall
      // through to the bundle handler.
      const dot = event.target.closest('[data-look-dot]');
      if (dot) {
        const idx = dot.getAttribute('data-look-index');
        this.activate(idx, { scroll: true });
        return;
      }
      super.onClick(event);
    }
    onShopKeydown(event) {
      if (event.key === 'Escape' && this.activeIndex != null) {
        this.clearActive();
      }
    }
    onRowPointer(event) {
      const row = event.target.closest('[data-look-row]');
      if (!row) return;
      const dot = this.dotByIndex(row.getAttribute('data-look-index'));
      if (dot) dot.classList.toggle('is-emph', event.type === 'pointerover');
    }
    onRowFocus(event) {
      const row = event.target.closest('[data-look-row]');
      if (!row) return;
      const dot = this.dotByIndex(row.getAttribute('data-look-index'));
      if (dot) dot.classList.toggle('is-emph', event.type === 'focusin');
    }
    activate(idx, opts) {
      opts = opts || {};
      if (this.activeIndex === idx) { this.clearActive(); return; }
      this.clearActive();
      this.activeIndex = idx;
      const row = this.rowByIndex(idx);
      const dot = this.dotByIndex(idx);
      if (row) row.classList.add('is-active');
      if (dot) dot.classList.add('is-active');
      if (row && opts.scroll) {
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        try { row.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'nearest' }); }
        catch (e) { row.scrollIntoView(); }
      }
    }
    clearActive() {
      if (this.activeIndex == null) return;
      const row = this.rowByIndex(this.activeIndex);
      const dot = this.dotByIndex(this.activeIndex);
      if (row) row.classList.remove('is-active');
      if (dot) dot.classList.remove('is-active');
      this.activeIndex = null;
    }
  }
  if (!customElements.get('look-shoppable')) customElements.define('look-shoppable', LookShoppable);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
